export { SearchResults as default } from './SearchResults'
